import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-administrator-resources" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "app-administrator-resources-root" }
const _hoisted_4 = { class: "section-default" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "headline" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Resursi ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdministratorNavigationVue = _resolveComponent("AdministratorNavigationVue")!
  const _component_AdministratorResourcesNavigationVue = _resolveComponent("AdministratorResourcesNavigationVue")!
  const _component_AppAdministratorResourcesRootExercisesIndexVue = _resolveComponent("AppAdministratorResourcesRootExercisesIndexVue")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_AppAdministratorResourcesRootDietsIndexVue = _resolveComponent("AppAdministratorResourcesRootDietsIndexVue")!
  const _component_AppAdministratorResourcesRootSupplementsIndexVue = _resolveComponent("AppAdministratorResourcesRootSupplementsIndexVue")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AdministratorNavigationVue),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AdministratorResourcesNavigationVue),
        _createElementVNode("section", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_row, {
            gutter: 16,
            type: "flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppAdministratorResourcesRootExercisesIndexVue)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppAdministratorResourcesRootDietsIndexVue)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 8,
                lg: 8,
                xl: 8
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AppAdministratorResourcesRootSupplementsIndexVue)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}